import { useQuery } from 'react-query';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { useDateFns, useProvider } from '~/Hooks';
import { ExtendedEventSeries } from '~/Screens/Events/EventCreate/EventCreateSections/EventScheduleSection/extendedEventSeries.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { TIME_VALUES } from '~/Constants/Date.constants';

interface ICountBookingsResponse {
  label: string;
  count: number;
}

export const useCheckEventSeriesBookings = (
  timeSeries: ExtendedEventSeries,
  onlyFuture?: boolean,
) => {
  const { currentProvider } = useProvider();
  const { startOfTodayAsUTCString } = useDateFns();
  const begin = onlyFuture ? startOfTodayAsUTCString() : timeSeries.startDate;

  return useQuery<ICountBookingsResponse[], IErrorResponse>(
    [timeSeries.id, timeSeries.endDate, begin],
    async () =>
      requestReactQuery<ICountBookingsResponse[]>({
        url: CORE_SERVICE_URLS.COUNT_BOOKINGS,
        config: { method: 'GET' },
        apiVersion: '2',
        params: {
          domain: currentProvider?.uuid,
          granularity: 'Total',
          begin,
          end: timeSeries.endDate,
          eventSeriesId: timeSeries.id,
        },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      cacheTime: 5 * TIME_VALUES.MINUTE,
      enabled: !!timeSeries.id,
    },
  );
};
